import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { installErrorHooks, reportError } from "@/lib/errors";
import "@/styles/globals.css";

installErrorHooks("front");

const container = document.getElementById("root");
if (!container) throw new Error("Нет #root — index.html не тот");

// React 19: падения рендера — сюда (пойманные границей и нет), с компонентным стеком.
createRoot(container, {
  onUncaughtError: (error, info) => reportError(error, { component: info.componentStack }),
  onCaughtError: (error, info) => reportError(error, { component: info.componentStack }),
}).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
